import { render, staticRenderFns } from "./SendBasket.vue?vue&type=template&id=c2db83fa&"
import script from "./SendBasket.vue?vue&type=script&lang=js&"
export * from "./SendBasket.vue?vue&type=script&lang=js&"
import style0 from "./SendBasket.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SendBasket.vue"
export default component.exports